import { render, staticRenderFns } from "./Nicknames-Single-Admin.vue?vue&type=template&id=74178476"
import script from "./Nicknames-Single-Admin.js?vue&type=script&lang=js&external"
export * from "./Nicknames-Single-Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports